/**
 * reportService — frontend wrappers around the
 * /api/v1/chat/conversations/{publicId}/report endpoints (the Ion report feature).
 *
 * Each function returns parsed JSON on success and throws on non-2xx.
 */
import { authenticatedFetch } from './authService.js'
import { getApiBase } from '../components/admin/analytics/shared/formatters.js'

const BASE = (publicId) => `${getApiBase()}/chat/conversations/${encodeURIComponent(publicId)}/report`

async function jsonOrThrow(res) {
  if (res.ok) return await res.json()
  let detail = `HTTP ${res.status}`
  try { const b = await res.json(); if (b?.detail) detail = b.detail } catch {}
  throw new Error(detail)
}

export async function getReport(publicId) {
  return jsonOrThrow(await authenticatedFetch(BASE(publicId)))
}

export async function saveReport(publicId, { sections, rationale } = {}) {
  return jsonOrThrow(await authenticatedFetch(BASE(publicId), {
    method: 'PUT', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ sections, rationale }),
  }))
}

export async function draftRationale(publicId) {
  return jsonOrThrow(await authenticatedFetch(
    `${BASE(publicId)}/rationale`,
    { method: 'POST' }
  ))
}

export function reportPdfUrl(publicId) {
  return `${BASE(publicId)}.pdf`
}

/**
 * Download report PDF with authentication.
 * The PDF endpoint requires Bearer token auth, so we use authenticatedFetch
 * to fetch the blob, then create a temporary download link.
 */
export async function downloadReportPdf(publicId, filename = 'report.pdf') {
  const res = await authenticatedFetch(reportPdfUrl(publicId))
  if (!res.ok) {
    let detail = `HTTP ${res.status}`
    try { const b = await res.json(); if (b?.detail) detail = b.detail } catch {}
    throw new Error(detail)
  }

  const blob = await res.blob()
  const objectUrl = URL.createObjectURL(blob)

  try {
    const link = document.createElement('a')
    link.href = objectUrl
    link.download = filename
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  } finally {
    URL.revokeObjectURL(objectUrl)
  }
}
